import React, { useEffect, useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbarcopy";
import { useLocation } from "react-router-dom";
import { RequestClockInTable, RequestCompensatorytable, RequestExpensetable, RequestImpresttable, RequestLeavetable, RequestMisspunchtable, Requestoutdutytable, TeamLeaveLogTable } from "../workforcemanagement/tlwfm/TlRequestoutdutytable";
import { RequestRequisitionTableAdmin, RequestRequisitionTableRH } from "../RequisitionManagement/RequisitionManagementTables";
import { LogCompensatorytable, RequestClockInTableHR, RequestExpensetableAdmin, RequestExpensetableHOD, RequestImpresttableAdmin, RequestImpresttableHOD } from "../workforcemanagement/Requestoutdutytable";
import Requestmanagment from "../workforcemanagement/Requestmanagment";
import { AppraisalFormsTableHOD, AppraisalFormsTableHODAdmin, AppraisalFormsTableRH, AppraisalFormsTableRHHOD, AppraisalFormsTableRHHODAdmin, AppraisalPendingApprovalsList } from "../AppraisalManagement/AppraisalTables";
import { AdvanceFormsTableAdmin, AdvanceFormsTableHOD, AdvanceFormsTableRH } from "../AdvanceManagement/AdvanceTables";
import { SeprationFormsTableAdmin, SeprationFormsTableHOD, SeprationFormsTableRH } from "../SeprationManagement/SeprationTables";
import { ImprestExpenseDashboard } from "../ImprestExpenseManagement/ImprestExpenseComponents";
import { AdvanceFormsTableAcc } from "../AdvanceManagement/AdvanceTables";
import { SeprationFormsTableAcc } from "../SeprationManagement/SeprationTables";
import EmployeeStarRanking from "../AppraisalManagement/EmployeeStarRanking"
import TeamEmployeeStarRanking from "../AppraisalManagement/TeamEmployeeStarRanking"


const TeamRequestsManagementTab = () => {

    // const [toggleState, setToggleState] = useState(1);
    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 1;
    const secondtoggle = location.state !== null ? location.state?.secondtoggle : 1;
    const [toggleState, setToggleState] = useState(secondtoggle);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 0:
                return 'My Team Clockins';
            case 1:
                return 'My Team OutDuties';
            case 2:
                return 'My Team Leaves';
            case 3:
                return 'My Team Compensatory Requests';
            case 4:
                return 'My Team Imprests';
            case 5:
                return 'My Team Expenses';
            case 6:
                return 'My Team Requisition Requests';
            case 7:
                return 'My Team Leave History Log';
            case 8:
                return 'My Team Appraisal Forms';
            case 9:
                return 'My Team Advance Requests';
            case 10:
                return 'My Team Separation Requests';
            case 11:
                return 'My Team Star Ranking';
            default:
                return 'My Team Requests';
        }
    };

    return (
        <>
            <Dashboardnavbarcopy name={getSelectedTitle()} url="Team Request Management" />
            <div className="content-tabs">
                {/* <TeamRequestManagment secondtoggle={secondtoggle} /> */}
                <>
                    <div>
                        <div className="bloc-tabs-with-white-bg">
                            {/*  //? @SC Customization */}
                            {/* view in SC hide for CIPL/GENG */}
                            {sessionStorage.getItem("company") === "Space Creattors" || sessionStorage.getItem("company") === "Space Creattors Heights" ?
                                <button
                                    className={toggleState === 0 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                    onClick={() => setToggleState(0)}
                                >
                                    Team Clock-Ins
                                </button> : ""}
                            <button
                                className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(1)}
                            >
                                Out Duty
                            </button>
                            <button
                                className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(2)}
                            >
                                Leave
                            </button>

                            {/* <button
                                className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(3)}
                            >
                                Compensatory Leave
                            </button> */}
                            <button
                                className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(4)}
                            >
                                Imprest
                            </button>
                            <button
                                className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(5)}
                            >
                                Expense
                            </button>
                            <button
                                className={toggleState === 6 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(6)}
                            >
                                Requisition Requests
                            </button>
                            {/* <button
                                className={toggleState === 7 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(7)}
                            >
                                Leave History Log
                            </button> */}
                            {/* {sessionStorage.getItem('company_id') === "beb197dd-9ad1-4136-a1ad-bb469e7127a2" ? */}
                            {/* null : */}
                            <button
                                className={toggleState === 8 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(8)}
                            >
                                Team Appraisal Forms
                            </button>
                            {/* } */}
                            {/* <button
                                className={toggleState === 9 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(9)}
                            >
                                Team Advance Requests
                            </button> */}
                            <button
                                className={toggleState === 10 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(10)}
                            >
                                Team Separation Requests
                            </button>
                            <button
                                className={toggleState === 11 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(11)}
                            >
                                Star Ranking
                            </button>
                        </div>

                        <div className="content-tabs-without-margin">
                            {toggleState === 0 ? <RequestClockInTable /> : null}
                            {toggleState === 1 ? <Requestoutdutytable /> : null}
                            {toggleState === 2 ? <RequestLeavetable /> : null}
                            {/* {toggleState === 3 ? <RequestCompensatorytable /> : null} */}

                            {toggleState === 4 ? <RequestImpresttable /> : null}
                            {toggleState === 5 ? <RequestExpensetable /> : null}

                            {toggleState === 6 ? <RequestRequisitionTableRH /> : null}
                            {toggleState === 7 ? <TeamLeaveLogTable /> : null}
                            {/* {toggleState === 8 ? <AppraisalFormsTableRH /> : null} */}
                            {toggleState === 8 ? <AppraisalPendingApprovalsList level={1} /> : null}

                            {toggleState === 9 ? <AdvanceFormsTableRH /> : null}
                            {toggleState === 10 ? <SeprationFormsTableRH /> : null}
                            {toggleState === 11 ? <TeamEmployeeStarRanking /> : null}
                        </div>
                    </div>
                </>
            </div >
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const HODRequestsManagementTab = () => {
    const location = useLocation();
    const [toggleState, setToggleState] = useState(3);

    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 7;
    const secondtoggle = location.state !== null ? location.state?.secondtoggle : 1;
    const [toggleValue, setToggleValue] = useState(secondtoggle);
    const getSelectedTitle = (toggleState) => {
        switch (toggleState) {
            case 1:
                return 'Imprest Requests';
            case 2:
                return 'Expense Requests';
            case 3:
                return 'Appraisal Forms';
            case 4:
                return 'Advance Requests';
            case 5:
                return 'Separation Requests';
            default:
                return 'Requests Management';
        }
    };

    return (
        <>
            <Dashboardnavbarcopy name={getSelectedTitle(toggleState)} url="Department Requests Management" />

            <div className="bloc-tabss  wfm-margin">
                {/* <button
                    className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                    onClick={() => setToggleState(1)}
                >
                    Imprests
                </button>
                <button
                    className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                    onClick={() => setToggleState(2)}
                >
                    Expenses
                </button> */}
                <button
                    className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                    onClick={() => setToggleState(3)}
                >
                    Appraisal Forms
                </button>
                <button
                    className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                    onClick={() => setToggleState(4)}
                >
                    Advance Requests
                </button>
                <button
                    className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                    onClick={() => setToggleState(5)}
                >
                    Separation Requests
                </button>
            </div>
            <div className="content-tabs">

                {toggleState === 1 ?
                    <RequestImpresttableHOD />
                    : null
                }
                {toggleState === 2 ?
                    <RequestExpensetableHOD />
                    : null
                }

                {/* {toggleState === 3 ?
                    sessionStorage.getItem('company_id') === "beb197dd-9ad1-4136-a1ad-bb469e7127a2" ?
                        <AppraisalFormsTableHOD />
                        :
                        <AppraisalFormsTableRHHOD />
                    : null} */}

                {toggleState === 3 ?
                    <AppraisalPendingApprovalsList level={2} />
                    : null}

                {toggleState === 4 ?
                    <AdvanceFormsTableHOD />
                    : null
                }

                {toggleState === 5 ? <SeprationFormsTableHOD /> : null}

            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

        </>
    );
};

const HRRequestsManagementTab = () => {
    const location = useLocation();

    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 7;
    const secondtoggle = location.state !== null ? location.state?.secondtoggle : 1;
    const [toggleValue, setToggleValue] = useState(secondtoggle);
    const getSelectedTitle = (toggleState) => {
        switch (toggleState) {
            case 1:
                return 'OutDuties Requests';
            case 2:
                return 'Leaves Requests';
            case 3:
                return 'Misspunch Requests';
            case 4:
                return 'Compensatory Requests';
            case 5:
                return 'Imprest Requests';
            case 6:
                return 'Expense Requests';
            case 7:
                return 'Requisition Requests';
            case 8:
                return 'Clockins';
            case 9:
                return 'Advance Requests';
            case 10:
                return 'Separation Requests';
            case 12:
                return 'Star Ranking';
            default:
                return 'Requests Management';
        }
    };

    return (
        <>
            <Dashboardnavbarcopy name={getSelectedTitle(toggleValue)} url="HR Requests Management" />
            {/* <Dashboardnavbarcopy name={"Requests Management"} url="HR Requests Management" /> */}
            <div className="content-tabs">
                <Requestmanagment secondtoggle={secondtoggle} setToggleValue={setToggleValue} />
            </div >
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const AdminRequestsManagementTab = () => {

    // const [toggleState, setToggleState] = useState(1);
    const location = useLocation();
    const firsttoggle = location.state !== null ? location.state?.firsttoggle : 1;
    const secondtoggle = location.state !== null ? location.state?.secondtoggle : 8;
    const [toggleState, setToggleState] = useState(secondtoggle);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 0:
                return 'Clock-In Logs';
            case 1:
                return 'Imprest Requests';
            case 2:
                return 'Expense Requests';
            case 3:
                return 'Compensatory Logs';
            case 4:
                return 'Requisition Requests';
            case 5:
                return 'Appraisal Forms';
            case 6:
                return 'Advance Requests';
            case 7:
                return 'Separation Requests';
            case 9:
                return 'Star Ranking';

            default:
                return 'Admin Requests Management';
        }
    };

    return (
        <>
            <Dashboardnavbarcopy name={getSelectedTitle()} url="Admin Requests Management" />
            <div className="content-tabs">
                {/* <TeamRequestManagment secondtoggle={secondtoggle} /> */}
                <>
                    <div>
                        <div className="bloc-tabs-with-white-bg">
                            {/*  //? @SC Customization */}
                            {/* view in SC hide for CIPL/GENG */}
                            {sessionStorage.getItem("company") === "Space Creattors" ||
                                sessionStorage.getItem("company") === "Space Creattors Heights" ? (
                                <button
                                    className={
                                        toggleState === 0
                                            ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                            : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                    }
                                    onClick={() => setToggleState(0)}
                                >
                                    Clock-In Log
                                </button>
                            ) : null}
                            <button
                                className={toggleState === 8
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(8)}
                            >
                                Imprest Expense Dashboard
                            </button>
                            <button
                                className={
                                    toggleState === 1
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(1)}
                            >
                                Imprest
                            </button>
                            <button
                                className={
                                    toggleState === 2
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(2)}
                            >
                                Expense
                            </button>
                            {/* <button
                                className={
                                    toggleState === 3
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(3)}
                            >
                                Compensatory Leaves Log
                            </button> */}
                            <button
                                className={toggleState === 4
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(4)}
                            >
                                Requisition Requests
                            </button>
                            <button
                                className={toggleState === 5
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(5)}
                            >
                                Appraisal Forms
                            </button>
                            <button
                                className={toggleState === 6
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(6)}
                            >
                                Advance Requests
                            </button>
                            <button
                                className={toggleState === 7
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(7)}
                            >
                                Separation Requests
                            </button>

                            <button
                                className={toggleState === 9 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                                onClick={() => setToggleState(9)}
                            >
                                Star Ranking
                            </button>

                        </div>

                        <div className="content-tabs-without-margin">
                            {toggleState === 0 ? <RequestClockInTableHR /> : null}
                            {toggleState === 1 ? <RequestImpresttableAdmin /> : null}
                            {toggleState === 2 ? <RequestExpensetableAdmin /> : null}
                            {toggleState === 3 ? <LogCompensatorytable /> : null}
                            {toggleState === 4 ? <RequestRequisitionTableAdmin /> : null}
                            {/* {toggleState === 5 ?
                                sessionStorage.getItem('company_id') === "beb197dd-9ad1-4136-a1ad-bb469e7127a2" ?
                                    <AppraisalFormsTableHODAdmin />
                                    :
                                    <AppraisalFormsTableRHHODAdmin />
                                : null} */}
                            {toggleState === 5 ?
                                <AppraisalPendingApprovalsList level={3} />
                                : null}
                            {toggleState === 6 ? <AdvanceFormsTableAdmin /> : null}
                            {toggleState === 7 ? <SeprationFormsTableAdmin /> : null}
                            {toggleState === 8 ? <ImprestExpenseDashboard /> : null}
                            {toggleState === 9 ? <EmployeeStarRanking /> : null}

                        </div>
                    </div>
                </>
            </div >
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const AccountsRequestMangement = () => {
    const location = useLocation();
    const accfirsttoggle = location.state !== null ? location.state?.accfirsttoggle : 1;
    const [toggleState, setToggleState] = useState(accfirsttoggle);
    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return "Advance Requests";
            case 2:
                return "Separation Requests";
            default:
                return "Accounts Requests Management";
        }
    };

    return (
        <>
            <div>
                <Dashboardnavbarcopy name={getSelectedTitle()} url="Accounts Request Management" />
                <div className="bloc-tabs-with-white-bg content-tabs">
                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                        onClick={() => setToggleState(1)}
                    >
                        Advance Requests
                    </button>
                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"}
                        onClick={() => setToggleState(2)}
                    >
                        Separation Requests
                    </button>
                </div>
            </div>
            <div className="content-tabs">
                {toggleState === 1 ? <AdvanceFormsTableAcc /> : null}
                {toggleState === 2 ? <SeprationFormsTableAcc /> : null}
            </div>
        </>
    )
}

export {
    TeamRequestsManagementTab,
    HODRequestsManagementTab,
    HRRequestsManagementTab,
    AdminRequestsManagementTab,
    AccountsRequestMangement,
};
